/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {APP_BASE_HREF} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {ThemeModule} from './@theme/theme.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {AuthGuard} from './auth/services/auth-guard.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NbSecurityModule} from './security/security.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FileSaverModule} from 'ngx-filesaver';
import {SharedTranslationModule} from './shared-translation.module';
import {Globals} from './globals';
import {UserApiService} from './@core/data/user-api.service';
import {ReportApiService} from './@core/data/report-api.service';
import {NbDateFnsDateModule} from '@nebular/date-fns';
import {NbApiRoleProvider} from './security/services/api-role.provider';
import {NbRoleProvider} from './security/services/role.provider';
import {NbAuthJWTInterceptor} from './auth/services/interceptors/jwt-interceptor';
import { PermissionService } from './security/services/permission.service';


declare var require: any;

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    RouterModule,
    DragDropModule,
    FileSaverModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    SharedTranslationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NbDateFnsDateModule.forRoot({
      parseOptions: { awareOfUnicodeTokens: true },
      format: 'dd/MM/yyyy',
      formatOptions: { awareOfUnicodeTokens: true },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: APP_BASE_HREF, useValue: '/'},
    {provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true},
    NbSecurityModule.forRoot({
      accessControl: {},
    }).providers,
    {provide: NbRoleProvider, useClass: NbApiRoleProvider},
    AuthGuard,
    Globals,
    PermissionService,
    UserApiService,
    ReportApiService
  ],
})
export class AppModule {

}
